import { connect } from 'react-redux';
import { priceImprovementBlotter } from 'state/selectors';
import type { AppState } from 'state/state.model';

export type PriceImprovementSummaryProps = OwnProps & StateProps;

export interface OwnProps {
  id: string;
  quoteId: string;
}

export interface StateProps {
  pricerId: string;
  salesDesk: string;
  salesName: string;
  salesComment?: string;
  underlyings: string;
}

export const mapStateToProps = (state: AppState): StateProps => {
  const { pricerId, salesDesk, salesComment, requester, underlyings } = priceImprovementBlotter.getDetailItem(state)!;

  return {
    pricerId,
    salesDesk,
    salesComment,
    salesName: requester,
    underlyings: underlyings?.replace(/;/g, ','),
  };
};

export const connectPriceImprovementSummary = connect(mapStateToProps);
